import { ApiError } from "../types/api-error";

export const errorMessages = {
  [ApiError.OtherError]: "Wystąpił Błąd",
  [ApiError.NotFound]: "Nie Znaleziono",
  [ApiError.AlreadyExist]: "Zasób o podanych parametrach już istnieje",
  [ApiError.AlreadyInUse]: "Już Używany",
  [ApiError.DatabaseError]: "Błąd Serwera",
  [ApiError.SendEmailError]: "Błąd Podczas Przesyłania",
  [ApiError.WrongDate]: "Podana Zła Data",
  [ApiError.PasswordIsNotGoodEnough]: "Hasło Nie Wystarczająco Dobre",
  [ApiError.UserWrongPassword]: "Błędne Dane Logowania",
  [ApiError.UserPasswordResetTokenExpired]:
    "Możliwość Zresetowania Hasła Wygasła",
  [ApiError.RefreshTokenExpired]: "Sesja Wygasła",
  [ApiError.TypeUserNotChoose]: "Typ Użytkownika Nie Wybrany",
  [ApiError.AccessDenied]: "Brak Dostępu",
  [ApiError.DateAvailabilityError]: "Data Niedostępna",
  [ApiError.AlreadyExistsIncludes]: "Już Istnieje",
  [ApiError.GoogleApiError]: "Błąd API Google",
  [ApiError.ConfirmingOffersTokenExpired]:
    "Token do potwierdzenia oferty wygasł",
  [ApiError.TooManySubcontractors]: "Zbyt dużo wykonawców/podwykonawców",
  [ApiError.FieldRequired]: "Pola wymagane nie są uzupełnione",
  [ApiError.TooManyPositions]: "Za duzo pozycji",
  [ApiError.PasswordReset]: "Hasło zostało zresetowane. Zmień hasło",
  [ApiError.WrongTypeOfOrder]:
    "Brak możliwości zmiany rodzaju oferty. Magazyn dedykowany może mieć tylko jedną ofertę, a multimagazyn minimum dwie",
  [ApiError.LoginAlreadyExist]: "Login już istnieje",
  [ApiError.EmailAlreadyExist]: "Email już istnieje",
  [ApiError.AlreadyPlaced]: "Wszystkie przedmioty składowania są już rozmieszczone w istniejącej ofercie",
};
